export const EMPTY_TRANSACTIONS = {
  totalTransactions: 0,
  successfulTransactions: 0,
  failedTransactions: 0,
  pendingTransactions: 0,
  totalPendingAmount: 0,
  totalSuccessfulAmount: 0,
  lastUpdated: null,
};
